import { render, staticRenderFns } from "./PhysicalCountV2.vue?vue&type=template&id=1e7241ce&scoped=true"
import script from "./PhysicalCountV2.vue?vue&type=script&lang=js"
export * from "./PhysicalCountV2.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCountV2.vue?vue&type=style&index=0&id=1e7241ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7241ce",
  null
  
)

export default component.exports